import { Modal } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';

import Button from '../../generic/Button/Button';
import { BUTTON_SIZE, BUTTON_TYPE } from '../../generic/Button/button-constants';
import ButtonGroup from '../../generic/Button/ButtonGroup';
import LoaderButton from '../../generic/Button/LoaderButton';

type Props = {
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  /** Label for the kind of report being unpublished (e.g. "SBOM", "Licensing Report"). */
  reportLabel?: string;
};

/**
 * Confirmation dialog for removing a published report from the organization
 * portal. The report can be republished at any time.
 */
export const UnpublishReportDialog: VoidFunctionComponent<Props> = ({
  onClose,
  onConfirm,
  isLoading,
  reportLabel = 'SBOM',
}) => (
  <Modal onHide={onClose} className="modal-confirm" show>
    <Modal.Header closeButton>
      <Modal.Title>Unpublish {reportLabel}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>
        This will remove the {reportLabel} for this release version from the portal. You can republish it at any time.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <ButtonGroup>
        <Button type="secondary" size={BUTTON_SIZE.MEDIUM} onClick={onClose}>
          Cancel
        </Button>
        <LoaderButton
          isLoading={isLoading}
          type={BUTTON_TYPE.PRIMARY}
          size={BUTTON_SIZE.MEDIUM}
          onClick={onConfirm}
        >
          Unpublish
        </LoaderButton>
      </ButtonGroup>
    </Modal.Footer>
  </Modal>
);
